/*
 * CT Experts
 *
 * The roster faces are the navigation: selecting one crossfades that expert's
 * detail panel in below. Markup is rendered server-side (Boost has flat section
 * blocks), so this only wires up selection, keyboard tabs, and touch swipe.
 *
 * Without JS every panel stays in normal flow, so the content is still readable.
 */
class CtExperts extends HTMLElement {
  connectedCallback() {
    this.roster = this.querySelector('.ct-experts__roster');
    this.panelsEl = this.querySelector('.ct-experts__panels');
    this.faces = Array.from(this.querySelectorAll('[data-expert-face]'));
    this.panels = Array.from(this.querySelectorAll('[data-expert-panel]'));
    this.index = 0;

    if (!this.roster || !this.panels.length) return;

    this.bindEvents();
    this.classList.add('is-initialized');
    this.select(0);
  }

  disconnectedCallback() {
    if (this.onBlockSelect) {
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }
  }

  bindEvents() {
    this.faces.forEach((face, i) => {
      face.addEventListener('click', () => this.select(i));
    });

    this.roster.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
      event.preventDefault();
      const delta = event.key === 'ArrowRight' ? 1 : -1;
      this.select((this.index + delta + this.faces.length) % this.faces.length, true);
    });

    // Swipe the detail area on touch as a bonus.
    if (this.panelsEl) {
      this.panelsEl.addEventListener(
        'touchstart',
        (event) => {
          this.touchX = event.changedTouches[0].clientX;
        },
        { passive: true }
      );

      this.panelsEl.addEventListener(
        'touchend',
        (event) => {
          if (typeof this.touchX !== 'number') return;
          const dx = event.changedTouches[0].clientX - this.touchX;
          if (Math.abs(dx) < 48) return;
          const next = this.index + (dx < 0 ? 1 : -1);
          if (next >= 0 && next < this.panels.length) this.select(next);
        },
        { passive: true }
      );
    }

    if (window.Shopify && window.Shopify.designMode) {
      this.onBlockSelect = (event) => {
        const panel = event.target.closest ? event.target.closest('[data-expert-panel]') : null;
        if (!panel || !this.contains(panel)) return;
        const index = this.panels.indexOf(panel);
        if (index > -1) this.select(index);
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }
  }

  select(index, focus) {
    this.index = index;

    this.panels.forEach((panel, i) => {
      panel.classList.toggle('is-active', i === index);
    });

    this.faces.forEach((face, i) => {
      const active = i === index;
      face.classList.toggle('is-active', active);
      face.setAttribute('aria-selected', active ? 'true' : 'false');
      face.tabIndex = active ? 0 : -1;
    });

    if (focus && this.faces[index]) this.faces[index].focus();
  }
}

if (!customElements.get('ct-experts')) {
  customElements.define('ct-experts', CtExperts);
}
